import React, { useState } from 'react';
import '../css/carousel_component.css';

const CarouselComponent = ({ mediaItems, productName }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    if (mediaItems.length === 0) return null;

    if (mediaItems.length === 1) {
        const media = mediaItems[0];
        return media.type === 'image' ? (
            <img
                src={media.url}
                alt={productName}
                className="item-image"
            />
        ) : (
            <video
                src={media.url}
                className="item-video"
                controls
                muted
            />
        );
    }

    const currentMedia = mediaItems[currentIndex];

    return (
        <div className="media-carousel">
            {currentMedia.type === 'image' ? (
                <img
                    src={currentMedia.url}
                    alt={productName}
                    className="item-image"
                />
            ) : (
                <video
                    src={currentMedia.url}
                    className="item-video"
                    controls
                    muted
                />
            )}
            <button
                className="carousel-arrow carousel-prev"
                onClick={() => setCurrentIndex(prev =>
                    prev === 0 ? mediaItems.length - 1 : prev - 1
                )}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
            </button>
            <button
                className="carousel-arrow carousel-next"
                onClick={() => setCurrentIndex(prev =>
                    prev === mediaItems.length - 1 ? 0 : prev + 1
                )}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </button>
            <div className="carousel-indicators">
                {mediaItems.map((_, index) => (
                    <button
                        key={index}
                        className={`carousel-indicator ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => setCurrentIndex(index)}
                    />
                ))}
            </div>
        </div>
    );
};

export default CarouselComponent;
